import React from 'react';
import { Pagination } from 'react-bootstrap';
import '../../assets/styles/SmartPagination.css'

const SmartPagination = ({
    page,
    setPage
}) => {

    // 搜索相关状态

    return (
        <Pagination>
            {/* 上一页按钮 */}
            <Pagination.Prev
                disabled={page.page_number === 1}
                onClick={() => setPage(prev => ({
                    ...prev,
                    page_number: Math.max(1, prev.page_number - 1)
                }))}
            />

            {/* 智能页码生成 */}
            {(() => {
                const total = page.total_pages
                const current = page.page_number
                const items = []
                const boundaryPages = 2  // 始终显示的首尾页数

                // 始终显示第一页
                items.push(
                    <Pagination.Item
                        key={1}
                        active={1 === current}
                        onClick={() => setPage(p => ({ ...p, page_number: 1 }))}>
                        {1}
                    </Pagination.Item>
                )

                // 左侧动态页码
                let left = Math.max(2, current - boundaryPages)
                let right = Math.min(total - 1, current + boundaryPages)

                // 保证左侧显示足够页码
                if (current - boundaryPages > 2) {
                    items.push(<Pagination.Ellipsis key="left-ellipsis" disabled />)
                }

                // 中间页码
                for (let i = left; i <= right; i++) {
                    items.push(
                        <Pagination.Item
                            key={i}
                            active={i === current}
                            onClick={() => setPage(p => ({ ...p, page_number: i }))}>
                            {i}
                        </Pagination.Item>
                    )
                }

                // 保证右侧显示足够页码
                if (current + boundaryPages < total - 1) {
                    items.push(<Pagination.Ellipsis key="right-ellipsis" disabled />)
                }

                // 始终显示最后一页（当总页数>1时）
                if (total > 1) {
                    items.push(
                        <Pagination.Item
                            key={total}
                            active={total === current}
                            onClick={() => setPage(p => ({ ...p, page_number: total }))}>
                            {total}
                        </Pagination.Item>
                    )
                }

                return items
            })()}

            {/* 下一页按钮 */}
            <Pagination.Next
                disabled={page.page_number >= page.total_pages}
                onClick={() => setPage(prev => ({
                    ...prev,
                    page_number: Math.min(page.total_pages, prev.page_number + 1)
                }))}
            />
        </Pagination>
    )
}

export default SmartPagination;